export class LoanCovenantModel {
    
        constructor(
            customerName: string,
            loanId: number,
            covenantDetail: string,
            covenantTypeId: number,
            covenantType: string,
            frequencyTypeId: number,
            mode:string,
            frequencyType: string,
            covenantAmount: number,
            covenantDate: Date,
            isPercentage: boolean,
            casaAccountId : number,
        ) {
    
        }
    }
    
    